// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { RunGroupOut } from './runGroupOut.zod.ts';

export const RunGroupListOut = zod.object({
  "groups": zod.array(RunGroupOut),
  "page": zod.int(),
  "page_size": zod.int(),
  "total": zod.int(),
  "total_cost_usd": zod.string(),
  "total_runs": zod.int()
});

export type RunGroupListOut = zod.input<typeof RunGroupListOut>;
export type RunGroupListOutOutput = zod.output<typeof RunGroupListOut>;
